import { Date } from "components/Form/components/Date/Date";
import { DateTime } from "components/Form/components/DateTime/DateTime";
import { LabelledFormElement } from "components/Form/components/SchemaForm/LabelledFormElement";
import type { ObjectPath } from "components/Form/components/SchemaForm/SchemaForm.types";
import {
    fieldContainerClassName,
    getUpdatedData,
} from "components/Form/components/SchemaForm/SchemaFormService";
import { Time } from "components/Form/components/Time/Time";
import { getLocalDateTime, getLocalTime, getUpdatedTime } from "config/ts-utils";
import { ConfigType as DayjsConfigType } from "dayjs";

interface DatePickerSchemaFormComponentProps {
    elementSchema: any;
    fieldValue: any;
    labelProps: any;
    errorMessage?: string;
    isReadOnly: boolean;
    setData: (data: any) => void;
    formData: any;
    dataPath: ObjectPath;
    actionButtons: JSX.Element | null;
}

export const DatePickerSchemaFormComponent = ({
    elementSchema,
    fieldValue,
    labelProps,
    errorMessage,
    isReadOnly,
    setData,
    formData,
    dataPath,
    actionButtons,
}: DatePickerSchemaFormComponentProps) => {
    const isOnlyDate = !elementSchema.element.includes("time");
    const isOnlyTime = elementSchema.element.includes("-time");
    const include_utcoffset = elementSchema.element.includes("with");
    const timeInLocalTime = isOnlyDate
        ? fieldValue || ""
        : isOnlyTime
        ? getLocalTime(fieldValue, include_utcoffset)
        : getLocalDateTime(fieldValue, "YYYY-MM-DD HH:mm:ss");
    const displayedTime = timeInLocalTime === "Invalid Date" ? "" : timeInLocalTime;
    const Component = isOnlyDate ? Date : isOnlyTime ? Time : DateTime;

    return (
        <LabelledFormElement {...labelProps}>
            <div className={fieldContainerClassName(errorMessage)}>
                <Component
                    identifier={elementSchema.label}
                    input={{
                        value: displayedTime,
                        onChange: (value: DayjsConfigType) => {
                            const formattedValue = getUpdatedTime(value, {
                                isOnlyTime,
                                isOnlyDate,
                                include_utcoffset,
                            });
                            setData(getUpdatedData(formData, dataPath, formattedValue));
                        },
                        isReadOnly: isReadOnly,
                    }}
                />
                {actionButtons}
            </div>
        </LabelledFormElement>
    );
};
